import { type ContentComponent, type ListContentOf, type ObjectContent, type ProductCardContent } from '../../../../types/construct.types';
import { ArticleProductCard } from '../../../content-components/product-card/product-card.component';

export interface ProductTilesSectionContent extends ObjectContent {
	fields: {
		group_items: ListContentOf<ProductCardContent>;
	};
}

export const ProductTilesSection: ContentComponent<ProductTilesSectionContent> = ({ content }) => {
	return (
		<div className="flex flex-wrap w-100">
			{content.fields.group_items.items.map((product, index) => (
				<div key={`${product.title}-${index}`} className="w-50 w-33-ns ph2 mb3">
					<ArticleProductCard product={product} />
				</div>
			))}
		</div>
	);
};
